import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getFontOpacityMenuItems } from './lib'

/**
 * Settings subtitles font opacity menu
 */
export const SettingsSubtitlesFontOpacityMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesFontOpacityMenu',
  'font_opacity',
  getFontOpacityMenuItems
)
